import { Icon } from "@twinkltech/curriculum-architect-component-library";
import { IconActionsExitToApp, IconEducationArticle } from "@twinkltech/web-ui";
import { Link } from "react-router-dom";

export const ResourceList = ({ children }: { children: React.ReactNode }) => {
  return <ul className="flex flex-col gap-3 ml-0">{children}</ul>;
};

export const ResourceListItem = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <li>{children}</li>;
};

export const ResourceListItemLink = ({
  children,
  className,
  variant = "planning-knowledge",
  ...props
}: {
  children: React.ReactNode;
  variant?: "planning-knowledge" | "learning-sequence" | "additional-resource";
} & React.ComponentProps<typeof Link>) => {
  return (
    <Link
      className={[
        "group relative block border border-neutral-150 rounded-[8px] pr-12 py-3 hover:bg-neutral-150 focus:bg-neutral-150 focus-within:outline-none focus-within:ring-2 focus-within:ring-blue-500 flex items-center gap-3 pl-3",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      {...props}
    >
      <span className="w-6 h-6 self-start">
        {variant === "planning-knowledge" && <IconEducationArticle />}
        {variant === "learning-sequence" && <Icon icon="Dictionary" />}
        {variant === "additional-resource" && <Icon icon="MenuBook" />}
      </span>
      <span className="line-clamp-2">{children}</span>
      <div className="relative ml-auto isolate">
        <IconActionsExitToApp className="absolute -top-3 -right-9 text-blue-850 group-visited:text-white! mix-blend-multiply" />
        <Icon
          className="absolute -top-3 -right-9 z-1 text-white group-visited:text-blue-850! mix-blend-multiply"
          icon="ListAltCheck"
        />
      </div>
    </Link>
  );
};
